module.exports = __webpack_public_path__ + "static/media/me.1ff145f0.jpg";